import { render, staticRenderFns } from "./MainSidebarLink.vue?vue&type=template&id=00b3d59a&"
import script from "./MainSidebarLink.vue?vue&type=script&lang=js&"
export * from "./MainSidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports